function Information() {
  return (
    <div className="parent">
      <div>
        <img src="imgs/contact.png" alt="none" />
      </div>
      <div className="div2">
        <p>CALL ME</p>
        <i className="bi bi-phone"></i>&nbsp;+20 114 456 1199
        <br />
        <br />
        <p>MY MAIL</p>
        <i className="bi bi-envelope"></i>
        &nbsp;zayman655@gmail.com
      </div>
    </div>
  );
}

export default Information;
